import React from 'react';
import { Button, Modal, ModalContent, ModalCloseButton } from '../common';

/**
 * Shown when create_session_partnership returns PLAYER_ALREADY_PARTNERED.
 */
export default function PartnershipConflictModal({
  isOpen,
  onClose,
  blockedPlayerName = 'This player',
  existingPartnerName = 'their current partner',
  onRemoveExisting,
  isLoading = false,
}) {
  if (!isOpen) return null;

  return (
    <Modal isOpen={isOpen} onClose={onClose}>
      <ModalContent size="medium">
        <ModalCloseButton onClose={onClose} />
        <h2 className="pr-8 text-lg font-semibold text-text-primary">Partnership conflict</h2>
        <p className="mt-3 text-sm text-text-secondary">
          <span className="font-medium text-text-primary">{blockedPlayerName}</span> is already paired
          with <span className="font-medium text-text-primary">{existingPartnerName}</span> in this session.
        </p>
        <p className="mt-2 text-sm text-text-secondary">
          Remove the existing partnership first, then create the new pair.
        </p>
        <div className="mt-6 flex flex-col-reverse gap-2 sm:flex-row sm:justify-end">
          <Button type="button" variant="outline" size="small" onClick={onClose} disabled={isLoading}>
            Cancel
          </Button>
          <Button
            type="button"
            variant="primary"
            size="small"
            onClick={onRemoveExisting}
            disabled={isLoading}
          >
            {isLoading ? 'Removing…' : 'Remove existing partnership'}
          </Button>
        </div>
      </ModalContent>
    </Modal>
  );
}
